import * as Yup from 'yup'
import { FormValues } from '../../types/auth-form.types'
import { MIN_PASSWORD_LENGTH } from '../../constants/flowcode'
import { Resolver } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

export const authFormYupValidation = (
  isSignUp?: boolean,
  isSSO?: boolean
): Resolver<FormValues, Record<string, unknown>> => {
  const schema = Yup.object().shape({
    email: Yup.string().email('Invalid email address').required(),
    password: Yup.string()
      //empty string for key throws an error, using $other as a placeholder
      .when('$other', (_, schema) => (isSSO ? schema.notRequired() : schema.required()))
      .min(
        isSignUp ? MIN_PASSWORD_LENGTH : 6,
        `Password should be a minimum of ${MIN_PASSWORD_LENGTH} characters.`
      )
  })

  return yupResolver(schema)
}
